// data/localityAdjustments.js

export const localityAdjustments = {
  // Washington as default
  "DC": 1.3394, // Washington‑Baltimore‑Arlington, DC‑MD‑VA‑WV‑PA 33.94%
  
  // All other localities
  "ALBANY": 1.2077, // Albany‑Schenectady, NY‑MA 20.77%
  "ALBUQUERQUE": 1.1833, // Albuquerque‑Santa Fe‑Las Vegas, NM 18.33%
  "ATLANTA": 1.2379, // Atlanta–Athens–Clarke County–Sandy Springs, GA‑AL 23.79%
  "AUSTIN": 1.2035, // Austin‑Round Rock‑Georgetown, TX 20.35%
  "BIRMINGHAM": 1.1824, // Birmingham‑Hoover‑Talladega, AL 18.24%
  "BOSTON": 1.3258, // Boston‑Worcester‑Providence, MA‑RI‑NH‑CT‑ME‑VT 32.58%
  "BUFFALO": 1.2241, // Buffalo‑Cheektowaga‑Olean, NY 22.41%
  "BURLINGTON": 1.1945, // Burlington‑South Burlington‑Barre, VT 19.45%
  "CHARLOTTE": 1.1967, // Charlotte‑Concord, NC‑SC 19.67%
  "CHICAGO": 1.3086, // Chicago‑Naperville, IL‑IN‑WI 30.86%
  "CINCINNATI": 1.2193, // Cincinnati‑Wilmington‑Maysville, OH‑KY‑IN 21.93%
  "CLEVELAND": 1.2223, // Cleveland‑Akron‑Canton, OH‑PA 22.23%
  "COLORADO_SPRINGS": 1.2015, // Colorado Springs, CO 20.15%
  "COLUMBUS": 1.2215, // Columbus‑Marion‑Zanesville, OH 22.15%
  "CORPUS_CHRISTI": 1.1763, // Corpus Christi‑Kingsville‑Alice, TX 17.63%
  "DALLAS": 1.2726, // Dallas‑Fort Worth, TX‑OK 27.26%
  "DAVENPORT": 1.1893, // Davenport‑Moline, IA‑IL 18.93%
  "DAYTON": 1.2142, // Dayton‑Springfield‑Kettering, OH 21.42%
  "DENVER": 1.3052, // Denver‑Aurora, CO 30.52%
  "DES_MOINES": 1.1801, // Des Moines‑Ames‑West Des Moines, IA 18.01%
  "DETROIT": 1.2912, // Detroit‑Warren‑Ann Arbor, MI 29.12%
  "FRESNO": 1.1765, // Fresno‑Madera‑Hanford, CA 17.65%
  "HARRISBURG": 1.1943, // Harrisburg‑Lebanon, PA 19.43%
  "HARTFORD": 1.3208, // Hartford‑East Hartford, CT‑MA 32.08%
  "HOUSTON": 1.3500, // Houston‑The Woodlands, TX 35.00%
  "HUNTSVILLE": 1.2191, // Huntsville‑Decatur, AL‑TN 21.91%
  "INDIANAPOLIS": 1.1815, // Indianapolis‑Carmel‑Muncie, IN 18.15%
  "KANSAS_CITY": 1.1897, // Kansas City‑Overland Park‑Kansas City, MO‑KS 18.97%
  "LAREDO": 1.2159, // Laredo, TX 21.59%
  "LAS_VEGAS": 1.1957, // Las Vegas‑Henderson, NV‑AZ 19.57%
  "LA": 1.3647, // Los Angeles‑Long Beach, CA 36.47%
  "MIAMI": 1.2467, // Miami‑Port St. Lucie‑Fort Lauderdale, FL 24.67%
  "MILWAUKEE": 1.2242, // Milwaukee‑Racine‑Waukesha, WI 22.42%
  "MINNEAPOLIS": 1.2762, // Minneapolis‑St. Paul, MN‑WI 27.62%
  "NY": 1.3795, // New York‑Newark, NY‑NJ‑CT‑PA 37.95%
  "OMAHA": 1.1823, // Omaha‑Council Bluffs‑Fremont, NE‑IA 18.23%
  "PALM_BAY": 1.1793, // Palm Bay‑Melbourne‑Titusville, FL 17.93%
  "PHILADELPHIA": 1.2899, // Philadelphia‑Reading‑Camden, PA‑NJ‑DE‑MD 28.99%
  "PHOENIX": 1.2245, // Phoenix‑Mesa, AZ 22.45%
  "PITTSBURGH": 1.2103, // Pittsburgh‑New Castle‑Weirton, PA‑OH‑WV 21.03%
  "PORTLAND": 1.2613, // Portland‑Vancouver‑Salem, OR‑WA 26.13%
  "RALEIGH": 1.2224, // Raleigh‑Durham‑Cary, NC 22.24%
  "RENO": 1.1752, // Reno‑Fernley, NV 17.52%
  "RICHMOND": 1.2228, // Richmond, VA 22.28%
  "ROCHESTER": 1.1788, // Rochester‑Batavia‑Seneca Falls, NY 17.88%
  "SACRAMENTO": 1.2976, // Sacramento‑Roseville, CA‑NV 29.76%
  "SAN_ANTONIO": 1.1878, // San Antonio‑New Braunfels‑Pearsall, TX 18.78%
  "SAN_DIEGO": 1.3372, // San Diego‑Chula Vista‑Carlsbad, CA 33.72%
  "SF": 1.4634, // San Jose‑San Francisco‑Oakland, CA 46.34%
  "SEATTLE": 1.3157, // Seattle‑Tacoma, WA 31.57%
  "SPOKANE": 1.1767, // Spokane‑Spokane Valley‑Coeur d'Alene, WA‑ID 17.67%
  "ST_LOUIS": 1.2003, // St. Louis‑St. Charles‑Farmington, MO‑IL 20.03%
  "TUCSON": 1.1928, // Tucson‑Nogales, AZ 19.28%
  "VIRGINIA_BEACH": 1.1880, // Virginia Beach‑Norfolk, VA‑NC 18.80%
  "RUS": 1.1706, // Rest of United States 17.06%
  "ALASKA": 1.3236, // State of Alaska 32.36%
  "HAWAII": 1.2221  // State of Hawaii 22.21%
};